import axios from "axios"

export default {
    getMyInfo() {
        return axios.get("/course/Activity/getMyInfo");
    },
    submitJinniu(obj) {
        return axios.post("/course/Activity/submitJinniu", obj);
    }
}